webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"C:/front-end/ufon.brest/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"C:/front-end/ufon.brest/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"C:/front-end/ufon.brest/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"C:/front-end/ufon.brest/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"C:/front-end/ufon.brest/node_modules/babel-preset-stage-0/lib/index.js\",\"C:/front-end/ufon.brest/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__("./node_modules/babel-runtime/core-js/object/create.js");
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/iterator.js");
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.create.js");
	var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.keys.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.symbol.js");
	__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.observable.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
	var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
	module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
	var descriptor = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__("./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var $iterCreate = __webpack_require__("./node_modules/core-js/library/modules/_iter-create.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
	var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__("./node_modules/core-js/library/modules/_uid.js")('meta');
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var setDesc = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var dPs = __webpack_require__("./node_modules/core-js/library/modules/_object-dps.js");
	var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__("./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var gOPN = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
	var hiddenKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
	var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
	var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
	var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
	var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
	var defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('wks');
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	var Symbol = __webpack_require__("./node_modules/core-js/library/modules/_global.js").Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__("./node_modules/core-js/library/modules/_add-to-unscopables.js");
	var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	
	__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__("./node_modules/core-js/library/modules/_string-at.js")(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
	var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
	var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
	var META = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").KEY;
	var $fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
	var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js");
	var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
	var wks = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");
	var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
	var wksDefine = __webpack_require__("./node_modules/core-js/library/modules/_wks-define.js");
	var enumKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-keys.js");
	var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
	var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
	var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
	var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
	var _create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
	var gOPNExt = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn-ext.js");
	var $GOPD = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js");
	var $DP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
	var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
	  __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/library/modules/_library.js")) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__("./node_modules/core-js/library/modules/es6.array.iterator.js");
	var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
	var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
	var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
	var TO_STRING_TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),

/***/ "./node_modules/gatsby-link/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/index.js");
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/"; /*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    _this.state = {
	      to: normalizePath(pathPrefix + props.to)
	    };
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      this.setState({
	        to: normalizePath(pathPrefix + nextProps.to)
	      });
	      ___loader.enqueue(this.state.to);
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    ___loader.enqueue(this.state.to);
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this2.props[propName];
	    })) {
	      var El = _reactRouterDom.NavLink;
	    } else {
	      var El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function (_onClick) {
	        function onClick(_x) {
	          return _onClick.apply(this, arguments);
	        }
	
	        onClick.toString = function () {
	          return _onClick.toString();
	        };
	
	        return onClick;
	      }(function (e) {
	        onClick && onClick(e);
	        if (e.button === 0 && // ignore right clicks
	        !_this2.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this2.state.to;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this2.state.to.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this2.state.to);
	          }
	        }
	      })
	    }, rest, {
	      to: this.state.to
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(pathname) {
	  window.___navigateTo(normalizePath(pathPrefix + pathname));
	};

/***/ }),

/***/ "./node_modules/react-anime/dist/anime.min.js":
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__("./node_modules/react/react.js")):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports.ReactAnime=e(require("react")):t.ReactAnime=e(t.React)}(this,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return t[r].call(a.exports,a,a.exports,e),a.l=!0,a.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,e,n){Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=2)}([function(t,e,n){var r,a,o;!function(n,u){a=[],r=u,o="function"==typeof r?r.apply(e,a):r,!(void 0!==o&&(t.exports=o))}(this,function(){var t,e="1.1.1",n={duration:1e3,delay:0,loop:!1,autoplay:!0,direction:"normal",easing:"easeOutElastic",elasticity:400,round:!1,begin:void 0,update:void 0,complete:void 0},r=["translateX","translateY","translateZ","rotate","rotateX","rotateY","rotateZ","scale","scaleX","scaleY","scaleZ","skewX","skewY"],a="transform",o={arr:function(t){return Array.isArray(t)},obj:function(t){return Object.prototype.toString.call(t).indexOf("Object")>-1},svg:function(t){return t instanceof SVGElement},dom:function(t){return t.nodeType||o.svg(t)},num:function(t){return!isNaN(parseInt(t))},str:function(t){return"string"==typeof t},fnc:function(t){return"function"==typeof t},und:function(t){return void 0===t},nul:function(t){return"null"==typeof t},hex:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)},rgb:function(t){return/^rgb/.test(t)},hsl:function(t){return/^hsl/.test(t)},col:function(t){return o.hex(t)||o.rgb(t)||o.hsl(t)}},u=function(){var t={},e=["Quad","Cubic","Quart","Quint","Expo"],n={Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t,e){if(0===t||1===t)return t;var n=1-Math.min(e,998)/1e3,r=t/1,a=r-1,o=n/(2*Math.PI)*Math.asin(1);return-(Math.pow(2,10*a)*Math.sin((a-o)*(2*Math.PI)/n))},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,n=4;t<((e=Math.pow(2,--n))-1)/11;);return 1/Math.pow(4,3-n)-7.5625*Math.pow((3*e-2)/22-t,2)}};return e.forEach(function(t,e){n[t]=function(t){return Math.pow(t,e+2)}}),Object.keys(n).forEach(function(e){var r=n[e];t["easeIn"+e]=r,t["easeOut"+e]=function(t,e){return 1-r(1-t,e)},t["easeInOut"+e]=function(t,e){return.5>t?r(2*t,e)/2:1-r(t*-2+2,e)/2},t["easeOutIn"+e]=function(t,e){return.5>t?(1-r(1-2*t,e))/2:(r(2*t-1,e)+1)/2}}),t.linear=function(t){return t},t}(),i=function(t){return o.str(t)?t:t+""},c=function(t){return t.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()},s=function(t){if(o.col(t))return!1;try{var e=document.querySelectorAll(t);return e}catch(n){return!1}},f=function(t,e){return Math.floor(Math.random()*(e-t+1))+t},l=function(t){return t.reduce(function(t,e){return t.concat(o.arr(e)?l(e):e)},[])},p=function(t){return o.arr(t)?t:(o.str(t)&&(t=s(t)||t),t instanceof NodeList||t instanceof HTMLCollection?[].slice.call(t):[t])},d=function(t,e){return t.some(function(t){return t===e})},m=function(t,e){var n={};return t.forEach(function(t){var r=JSON.stringify(e.map(function(e){return t[e]}));n[r]=n[r]||[],n[r].push(t)}),Object.keys(n).map(function(t){return n[t]})},h=function(t){return t.filter(function(t,e,n){return n.indexOf(t)===e})},v=function(t){var e={};for(var n in t)e[n]=t[n];return e},g=function(t,e){for(var n in e)t[n]=o.und(t[n])?e[n]:t[n];return t},y=function(t){var e=/^#?([a-f\d])([a-f\d])([a-f\d])$/i,t=t.replace(e,function(t,e,n,r){return e+e+n+n+r+r}),n=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t),r=parseInt(n[1],16),a=parseInt(n[2],16),o=parseInt(n[3],16);return"rgb("+r+","+a+","+o+")"},b=function(t){var e,n,r,t=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t),a=parseInt(t[1])/360,o=parseInt(t[2])/100,u=parseInt(t[3])/100,i=function(t,e,n){return 0>n&&(n+=1),n>1&&(n-=1),1/6>n?t+6*(e-t)*n:.5>n?e:2/3>n?t+(e-t)*(2/3-n)*6:t};if(0==o)e=n=r=u;else{var c=.5>u?u*(1+o):u+o-u*o,s=2*u-c;e=i(s,c,a+1/3),n=i(s,c,a),r=i(s,c,a-1/3)}return"rgb("+255*e+","+255*n+","+255*r+")"},x=function(t){return o.rgb(t)?t:o.hex(t)?y(t):o.hsl(t)?b(t):void 0},w=function(t){return/([\+\-]?[0-9|auto\.]+)(%|px|pt|em|rem|in|cm|mm|ex|pc|vw|vh|deg)?/.exec(t)[2]},O=function(t,e,n){return w(e)?e:t.indexOf("translate")>-1?w(n)?e+w(n):e+"px":t.indexOf("rotate")>-1||t.indexOf("skew")>-1?e+"deg":e},M=function(t,e){if(e in t.style)return getComputedStyle(t).getPropertyValue(c(e))||"0"},j=function(t,e){var n=e.indexOf("scale")>-1?1:0,r=t.style.transform;if(!r)return n;for(var a=/(\w+)\((.+?)\)/g,o=[],u=[],i=[];o=a.exec(r);)u.push(o[1]),i.push(o[2]);var c=i.filter(function(t,n){return u[n]===e});return c.length?c[0]:n},A=function(t,e){return o.dom(t)&&d(r,e)?"transform":o.dom(t)&&(t.getAttribute(e)||o.svg(t)&&t[e])?"attribute":o.dom(t)&&"transform"!==e&&M(t,e)?"css":o.nul(t[e])||o.und(t[e])?void 0:"object"},k=function(t,e){switch(A(t,e)){case"transform":return j(t,e);case"css":return M(t,e);case"attribute":return t.getAttribute(e)}return t[e]||0},E=function(t,e,n){if(o.col(e))return x(e);if(w(e))return e;var r=w(w(t.to)?t.to:t.from);return!r&&n&&(r=w(n)),r?e+r:e},P=function(t){var e=/-?\d*\.?\d+/g;return{original:t,numbers:i(t).match(e)?i(t).match(e).map(Number):[0],strings:i(t).split(e)}},I=function(t,e,n){return e.reduce(function(e,r,a){var r=r?r:n[a-1];return e+t[a-1]+r})},_=function(t){var t=t?l(o.arr(t)?t.map(p):p(t)):[];return t.map(function(t,e){return{target:t,id:e}})},T=function(t,e){var r=[];for(var a in t)if(!n.hasOwnProperty(a)&&"targets"!==a){var u=o.obj(t[a])?v(t[a]):{value:t[a]};u.name=a,r.push(g(u,e))}return r},C=function(t,e,n,r){var a=p(o.fnc(n)?n(t,r):n);return{from:a.length>1?a[0]:k(t,e),to:a.length>1?a[1]:a[0]}},S=function(t,e,n,r){var a={};if("transform"===n)a.from=t+"("+O(t,e.from,e.to)+")",a.to=t+"("+O(t,e.to)+")";else{var o="css"===n?M(r,t):void 0;a.from=E(e,e.from,o),a.to=E(e,e.to,o)}return{from:P(a.from),to:P(a.to)}},$=function(t,e){var n=[];return t.forEach(function(r,a){var u=r.target;return e.forEach(function(e){var i=A(u,e.name);if(i){var c=C(u,e.name,e.value,a),s=v(e);s.animatables=r,s.type=i,s.from=S(e.name,c,s.type,u).from,s.to=S(e.name,c,s.type,u).to,s.round=o.col(c.from)||s.round?1:0,s.delay=(o.fnc(s.delay)?s.delay(u,a,t.length):s.delay)/H.speed,s.duration=(o.fnc(s.duration)?s.duration(u,a,t.length):s.duration)/H.speed,n.push(s)}})}),n},q=function(t,e){var n=$(t,e),r=m(n,["name","from","to","delay","duration"]);return r.map(function(t){var e=v(t[0]);return e.animatables=t.map(function(t){return t.animatables}),e.totalDuration=e.delay+e.duration,e})},L=function(t,e){t.tweens.forEach(function(n){var r=n.to,a=n.from,o=t.duration-(n.delay+n.duration);n.from=r,n.to=a,e&&(n.delay=o)}),t.reversed=!t.reversed},N=function(t){if(t.length)return Math.max.apply(Math,t.map(function(t){return t.totalDuration}))},V=function(t){var e=[],n=[];return t.tweens.forEach(function(t){"css"!==t.type&&"transform"!==t.type||(e.push("css"===t.type?c(t.name):"transform"),t.animatables.forEach(function(t){n.push(t.target)}))}),{properties:h(e).join(", "),elements:h(n)}},X=function(t){var e=V(t);e.elements.forEach(function(t){t.style.willChange=e.properties})},Y=function(t){var e=V(t);e.elements.forEach(function(t){t.style.removeProperty("will-change")})},F=function(t){var e=o.str(t)?s(t)[0]:t;return{path:e,value:e.getTotalLength()}},R=function(t,e){var n=t.path,r=t.value*e,a=function(a){var o=a||0,u=e>1?t.value+o:r+o;return n.getPointAtLength(u)},o=a(),u=a(-1),i=a(1);switch(t.name){case"translateX":return o.x;case"translateY":return o.y;case"rotate":return 180*Math.atan2(i.y-u.y,i.x-u.x)/Math.PI}},Z=function(t,e){var n=Math.min(Math.max(e-t.delay,0),t.duration),r=n/t.duration,a=t.to.numbers.map(function(e,n){var a=t.from.numbers[n],o=u[t.easing](r,t.elasticity),i=t.path?R(t,o):a+o*(e-a);return i=t.round?Math.round(i*t.round)/t.round:i});return I(a,t.to.strings,t.from.strings)},D=function(e,n){var r;e.currentTime=n,e.progress=n/e.duration*100;for(var o=0;e.tweens.length>o;o++){var u=e.tweens[o];u.currentValue=Z(u,n);for(var i=u.currentValue,c=0;u.animatables.length>c;c++){var s=u.animatables[c],f=s.id,l=s.target,p=u.name;switch(u.type){case"css":l.style[p]=i;break;case"attribute":l.setAttribute(p,i);break;case"object":l[p]=i;break;case"transform":r||(r={}),r[f]||(r[f]=[]),r[f].push(i)}}}if(r){t||(t=(M(document.body,a)?"":"-webkit-")+a);for(var o in r)e.animatables[o].target.style[t]=r[o].join(" ")}e.settings.update&&e.settings.update(e)},Q=function(t){var e={};return e.animatables=_(t.targets),e.settings=g(t,n),e.properties=T(t,e.settings),e.tweens=q(e.animatables,e.properties),e.duration=N(e.tweens)||t.duration,e.currentTime=0,e.progress=0,e.ended=!1,e},B=[],z=0,G=function(){var t=function(){z=requestAnimationFrame(e)},e=function(e){if(B.length){for(var n=0;B.length>n;n++)B[n].tick(e);t()}else cancelAnimationFrame(z),z=0};return t}(),H=function(t){var e=Q(t),n={};return e.tick=function(t){e.ended=!1,n.start||(n.start=t),n.current=Math.min(Math.max(n.last+t-n.start,0),e.duration),D(e,n.current);var r=e.settings;r.begin&&n.current>=r.delay&&(r.begin(e),r.begin=void 0),e.duration>n.current||(r.loop?(n.start=t,"alternate"===r.direction&&L(e,!0),o.num(r.loop)&&r.loop--):(e.ended=!0,e.pause(),r.complete&&r.complete(e)),n.last=0)},e.seek=function(t){D(e,t/100*e.duration)},e.pause=function(){Y(e);var t=B.indexOf(e);t>-1&&B.splice(t,1)},e.play=function(t){e.pause(),t&&(e=g(Q(g(t,e.settings)),e)),n.start=0,n.last=e.ended?0:e.currentTime;var r=e.settings;"reverse"===r.direction&&L(e),"alternate"!==r.direction||r.loop||(r.loop=1),X(e),B.push(e),z||G()},e.restart=function(){e.reversed&&L(e),e.pause(),e.seek(0),e.play()},e.settings.autoplay&&e.play(),e},J=function(t){for(var e=l(o.arr(t)?t.map(p):p(t)),n=B.length-1;n>=0;n--)for(var r=B[n],a=r.tweens,u=a.length-1;u>=0;u--)for(var i=a[u].animatables,c=i.length-1;c>=0;c--)d(e,i[c].target)&&(i.splice(c,1),i.length||a.splice(u,1),a.length||r.pause())};return H.version=e,H.speed=1,H.list=B,H.remove=J,H.easings=u,H.getValue=k,H.path=F,H.random=f,H})},function(e,n){e.exports=t},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function a(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);t.length>e;e++)n[e]=t[e];return n}return Array.from(t)}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var c=function(){function t(t,e){for(var n=0;e.length>n;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=n(1),f=r(s),l=n(0),p=r(l),d=function(t){function e(t){o(this,e);var n=u(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return m.call(n),n.targets=[],n}return i(e,t),c(e,[{key:"componentDidMount",value:function(){this.createAnime(this.props)}},{key:"shouldComponentUpdate",value:function(t){return this.createAnime(t),!0}},{key:"render",value:function(){var t=this,e=[];return this.props.children&&(e=Array.isArray(this.props.children)?this.props.children:[this.props.children]),f.default.createElement("g",null,e.map(function(e,n){return f.default.cloneElement(e,{key:n,ref:t.addTarget})}))}}]),e}(f.default.Component),m=function(){var t=this;this.createAnime=function(e){var n=Object.assign({},{targets:t.targets},e);delete n.children,t.anime=(0,p.default)(n)},this.addTarget=function(e){t.targets=[].concat(a(t.targets),[e])}};e.default=d}])});

/***/ }),

/***/ "./src/layouts/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__("./src/pages/images/thumbs/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _vk = __webpack_require__("./src/pages/images/svg/vk.svg");
	
	var _vk2 = _interopRequireDefault(_vk);
	
	var _telegram = __webpack_require__("./src/pages/images/svg/telegram.svg");
	
	var _telegram2 = _interopRequireDefault(_telegram);
	
	var _github = __webpack_require__("./src/pages/images/svg/github.svg");
	
	var _github2 = _interopRequireDefault(_github);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	    _inherits(Footer, _Component);
	
	    function Footer() {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Footer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'footer',
	            null,
	            _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement('img', { src: _logo2.default, width: '66', title: 'Ufon', alt: 'Ufon' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'social' },
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.vk.com/ufonium' },
	                    _react2.default.createElement('img', { src: _vk2.default, width: '20', alt: 'vkontakte' }),
	                    ' '
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tg://resolve?domain=ufona' },
	                    _react2.default.createElement('img', { src: _telegram2.default, width: '20', alt: 'telegram' }),
	                    ' '
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.github.com/ufon' },
	                    _react2.default.createElement('img', { src: _github2.default, width: '20', alt: 'github' }),
	                    ' '
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'copyright' },
	                '\xA9 2017 ufon.brest.by'
	            )
	        );
	    };
	
	    return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/layouts/Header.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAnime = __webpack_require__("./node_modules/react-anime/dist/anime.min.js");
	
	var _reactAnime2 = _interopRequireDefault(_reactAnime);
	
	var _logo = __webpack_require__("./src/pages/images/thumbs/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { Link, hashHistory } from 'react-router'
	
	var Menu = function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	        _classCallCheck(this, Menu);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this._onMenuClick = function () {
	            return _this.props.handleToggle();
	        };
	
	        _this.state = {
	            open: _this.props.open,
	            color: '#fcf652'
	        };
	
	        _this.menuItems = [{ id: 0, name: 'Blog', link: '/blog' }, { id: 1, name: 'Home', link: '/' }, { id: 2, name: 'Contact', link: '/contact' }];
	
	        _this.colors = ['#fcf652', '#52AFFC', '#FFA0D8', '#FF8282', '#66FC52'];
	
	        return _this;
	    }
	
	    Menu.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	        console.log(this.state.open, this.state.color);
	        this.setState({ open: props.open, color: props.open ? this.colors[Math.floor(Math.random() * this.colors.length)] : this.state.color });
	        //this.refs.menu.style.display = (props.open) ? 'block' : this.refs.menu.style.display;
	    };
	
	    Menu.prototype.render = function render() {
	        var _this2 = this;
	
	        var state = this.state.open;
	        var transformOrigin = this.state.open ? '50% 100%' : '50% 0';
	        var color = this.state.color;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactAnime2.default,
	                { easing: 'easeInOutQuint',
	                    autoplay: true,
	                    duration: 1000,
	                    begin: this.props.animeBegin,
	                    complete: this.props.animeComplete,
	                    scaleY: state ? [0, 1] : [1, 0] },
	                _react2.default.createElement('div', { style: { transformOrigin: transformOrigin, backgroundColor: color }, className: 'menu-background' })
	            ),
	            _react2.default.createElement(
	                'ul',
	                { style: { display: 'block' }, className: 'menu' },
	                _react2.default.createElement(
	                    _reactAnime2.default,
	                    {
	                        opacity: state ? [0, 1] : [1, 0],
	                        delay: 500,
	                        autoplay: true
	                    },
	                    this.menuItems.map(function (item, index) {
	                        return _react2.default.createElement(
	                            'li',
	                            { className: 'menu__item', key: index },
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: item.link, className: 'menu__link', onClick: function onClick() {
	                                        return _this2._onMenuClick();
	                                    } },
	                                item.name
	                            )
	                        );
	                    })
	                )
	            )
	        );
	    };
	
	    return Menu;
	}(_react.Component);
	
	var Header = function (_Component2) {
	    _inherits(Header, _Component2);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));
	
	        _this3._animeBegin = function () {
	            _this3.refs.menu.style.display = 'block';
	            _this3.setState({ animation: 'begin' });
	        };
	
	        _this3._animeComplete = function () {
	            _this3.refs.menu.style.display = _this3.state.open ? 'block' : 'none';
	            _this3.setState({ animation: 'complete' });
	        };
	
	        _this3._handleToggle = function () {
	
	            console.log(_this3.state.open);
	
	            if (_this3.state.animation == 'complete') {
	                _this3.setState({ open: !_this3.state.open });
	            }
	
	            if (_this3.state.stage) {
	                _this3.setState({ stage: false });
	            }
	        };
	
	        _this3.state = {
	            open: false,
	            animation: 'complete',
	            stage: true
	        };
	
	        return _this3;
	    }
	
	    Header.prototype.componentDidMounted = function componentDidMounted() {
	        this.refs.menu.style.display = 'none';
	    };
	
	    Header.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	
	        //console.log(this.state, nextProps);
	
	        if (nextState.animation == 'begin') {
	            /* Если идет анимация компонент не пререрисовываем */
	            return false;
	        } else if (nextState.animation == 'complete' && this.state.open !== nextState.open) {
	            /* Перерисовываем компонент, только если анимация завершилась и изменилось состояние меню. */
	            return true;
	        }
	
	        /* Если рассмотрели все случаи перерисовки компонента, то по умолчанию можно не перерисовывать. */
	
	        return false;
	    };
	
	    Header.prototype.render = function render() {
	        return _react2.default.createElement(
	            'header',
	            { role: 'header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement('img', { src: _logo2.default, width: '66', title: 'Ufon', alt: 'Ufon' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { onClick: this._handleToggle, className: this.state.open ? "menu-button is-active" : "menu-button", id: 'menuButton' },
	                    _react2.default.createElement('span', { className: 'burger-icon' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { ref: 'menu' },
	                !this.state.stage ? _react2.default.createElement(Menu, { handleToggle: this._handleToggle, animeBegin: this._animeBegin, animeComplete: this._animeComplete, open: this.state.open }) : null
	            )
	        );
	    };
	
	    return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__("./src/layouts/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__("./src/layouts/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__("./src/styles/main.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	        var children = _ref.children;
	        return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Header2.default, null),
	                _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        children()
	                ),
	                _react2.default.createElement(_Footer2.default, null)
	        );
	};
	
	Layout.propTypes = {
	        children: _propTypes2.default.any
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/images/svg/github.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/pages/images/svg/telegram.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ1NS43MzEgNDU1LjczMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDU1LjczMSA0NTUuNzMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCB4PSIwIiB5PSIwIiBzdHlsZT0iZmlsbDojNjFBOERFOyIgd2lkdGg9IjQ1NS43MzEiIGhlaWdodD0iNDU1LjczMSIvPg0KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMzU4Ljg0NCwxMDAuNkw1NC4wOTEsMjE5LjM1OWMtOS44NzEsMy44NDctOS4yNzMsMTguMDEyLDAuODg4LDIxLjAxMmw3Ny40NDEsMjIuODY4bDI4LjkwMSw5MS43MDYNCgkJYzMuMDE5LDkuNTc5LDE1LjE1OCwxMi40ODMsMjIuMTg1LDUuMzA4bDQwLjAzOS00MC44ODJsNzguNTYsNTcuNjY1YzkuNjE0LDcuMDU3LDIzLjMwNiwxLjgxNCwyNS43NDctOS44NTlsNTIuMDMxLTI0OC43Ng0KCQlDMzgyLjQzMSwxMDYuMjMyLDM3MC40NDMsOTYuMDgsMzU4Ljg0NCwxMDAuNnogTTMyMC42MzYsMTU1LjgwNkwxNzkuMDgsMjgwLjk4NGMtMS40MTEsMS4yNDgtMi4zMDksMi45NzUtMi41MTksNC44NDcNCgkJbC01LjQ1LDQ4LjQ0OGMtMC4xNzgsMS41OC0yLjM4OSwxLjc4OS0yLjg2MSwwLjI3MWwtMjIuNDIzLTcyLjI1M2MtMS4wMjctMy4zMDgsMC4zMTItNi44OTIsMy4yNTUtOC43MTdsMTY3LjE2My0xMDMuNjc2DQoJCUMzMjAuMDg5LDE0Ny41MTgsMzI0LjAyNSwxNTIuODEsMzIwLjYzNiwxNTUuODA2eiIvPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "./src/pages/images/svg/vk.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/pages/images/thumbs/logo.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.426fb137.png";

/***/ }),

/***/ "./src/styles/main.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-adffbb3a52ff71a8bbc9.js